import { CheckIcon, XIcon } from "lucide-react";
import type { ReactNode } from "react";

export const SectionStatusIndicator = ({
  children,
  complete,
}: {
  children: ReactNode;
  complete: boolean;
}) => {
  /* Render */
  const render = () => {
    return (
      <div className="group/section relative">
        <div className="absolute left-0 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 bg-transparent leading-none group-has-[[data-state=open]]/section:hidden">
          {complete ? (
            <CheckIcon
              className="h-5 w-5 -rotate-6 text-emerald-500"
              strokeWidth={2}
            />
          ) : (
            <XIcon className="h-5 w-5 text-red-400" strokeWidth={2} />
          )}
        </div>
        {children}
      </div>
    );
  };

  return render();
};
